module.exports = [ '$scope', '$controller', function($scope, $controller) {
    $scope.facilitySelected = $scope.ngDialogData.facility;
    $scope.facilityFocused  = ($scope.ngDialogData.facility ? $scope.ngDialogData.facility : $scope.facilities[0]);
    $scope.fromSelection = ($scope.ngDialogData.facility ? true : false);

    $scope.select = function(facility) {
        $scope.facilitySelected = facility;
    };

    $scope.$on('formContactController.setSelected', function(event, data) {
        $scope.facilitySelected = data;
    });

    $scope.$on('owlCarousel.selectedItemChanged', function(event, data) {
        if (data !== $scope.facilityFocused) {
            $scope.facilityFocused = data;
        }
    });
}];


//////////////////
// WEBPACK FOOTER
// ./assets/app/popupContact.controller.js
// module id = 9
// module chunks = 0